/**
 * Which edge of its button a dropdown panel hangs from.
 *
 * The all-tabs list opens under a chevron at the END of a tab strip: usually at the far
 * right (so the panel must grow to the LEFT), but in a strip with no tabs — DB Manager
 * before a table is opened, a Terminal with no session — the chevron is at the far left,
 * and a right-aligned panel opened 166 px outside the window.
 *
 * @param {DOMRect|{left:number,right:number}|null} buttonRect
 * @param {number} panelWidth px
 * @param {number} [viewportWidth]
 * @returns {{ left: number } | { right: number }} style for a panel absolutely positioned
 *   inside a box that wraps the button
 */
export function dropdownSide(buttonRect, panelWidth, viewportWidth = typeof window !== 'undefined' ? window.innerWidth : 1280) {
  const margin = 8;
  if (!buttonRect) return { right: 0 };
  const fitsGrowingLeft = buttonRect.right - panelWidth >= margin;
  const fitsGrowingRight = buttonRect.left + panelWidth <= viewportWidth - margin;
  // prefer growing left (the usual place); fall back to growing right; if neither fits,
  // whichever side has more room
  if (fitsGrowingLeft) return { right: 0 };
  if (fitsGrowingRight) return { left: 0 };
  return buttonRect.right >= viewportWidth - buttonRect.left ? { right: 0 } : { left: 0 };
}
